module.exports = __webpack_public_path__ + "static/media/Group 515.a9044a48.svg";